module.exports = __webpack_public_path__ + "img/img_works06.6f33123f.jpg";